import React, { useContext } from 'react';
import { ShopContext } from '../../Context/ShopContext';
import remove_icon from '../Assets/Frontend_Assets/cart_cross_icon.png';
import './CartItems.css';
import { useNavigate } from 'react-router-dom';
const CartItems = () => {
    const { getTotalCartAmount, all_product, cartItems, removeFromCart } = useContext(ShopContext);
    const navigate = useNavigate();
    return (
        <div className='cartitems'>
            <div className='cartitems-format-main'>
                <p>Products</p>
                <p>Title</p>
                <p>Price</p>
                <p>Size</p>
                <p>Quantity</p>
                <p>Total</p>
                <p>Remove</p>
            </div>
            <hr />

            {all_product.map((e) => {
                const sizes = cartItems[e.id];
                if (!sizes) return null;

                return Object.keys(sizes).map((size) => {
                    const quantity = sizes[size];
                    if (quantity > 0) {
                        return (
                            <div key={`${e.id}-${size}`}>
                                <div className='cartitems-format cartitems-format-main'>
                                    <img src={e.image} className='carticon-product-icon' alt="" />
                                    <p>{e.name}</p>
                                    <p>${e.new_price}</p>
                                    <p className='cartitems-size'>{size}</p>
                                    <button className='cartitems-quntity'>{quantity}</button>
                                    <p>${e.new_price * quantity}</p>
                                    <img
                                        src={remove_icon}
                                        className='carticon-remove-icon'
                                        onClick={() => removeFromCart(e.id, size)}
                                        alt="remove"
                                    />
                                </div>
                                <hr />
                            </div>
                        );
                    }
                    return null;
                });
            })}

            <div className='cartitems-down'>
                <div className='cartitems-total'>
                    <h1>Cart Totals</h1>
                    <div>
                        <div className='cartitems-total-item'>
                            <p>Subtotal</p>
                            <p>${getTotalCartAmount()}</p>
                        </div>
                        <hr />
                        <div className='cartitems-total-item'>
                            <p>Shipping Fee</p>
                            <h4 style={{ color: "green" }}>Free</h4>
                        </div>
                        <hr />
                        <div className='cartitems-total-item'>
                            <h3>Total</h3>
                            <h3>${getTotalCartAmount()}</h3>
                        </div>
                    </div>
                    <button onClick={() => navigate('/checkout')}>
                        Proceed To Checkout
                    </button>                </div>

                <div className='cartitems-promocode'>
                    <p>If you have a promo code, Enter here</p>
                    <div className='cartitems-promobox'>
                        <input type="text" placeholder='promo code' />
                        <button>Submit</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CartItems;